/**
 * Did the auth call fail because something timed out (an aborted auth fetch,
 * or the bounded lock wait in `@/lib/supabase`) rather than because of the
 * input's own validity? Both are "try again", not "your password is wrong".
 */
export const isTimeoutLikeAuthError = (error: unknown): boolean => {
  if (!error) return false;
  const name = (error as { name?: string }).name ?? "";
  const message = (error as { message?: string }).message ?? "";
  return (
    name === "AbortError" ||
    name === "TimeoutError" ||
    (error as { isAcquireTimeout?: boolean }).isAcquireTimeout === true ||
    /timed out|timeout|aborted|failed to fetch|network/i.test(message)
  );
};

/**
 * Did the auth call fail because the recovery/session token is gone (expired
 * link, or spent in another tab) rather than a real credential rejection?
 */
export const isSessionMissingAuthError = (error: unknown): boolean => {
  if (!error) return false;
  const message = (error as { message?: string }).message ?? "";
  return /session missing|session_not_found|jwt expired|not authenticated/i.test(
    message
  );
};
